import { DCEvent } from "../events/eventsDomain";
import { Language } from "../i18n/languages";

export type UserPrefs = {
  lang?: Language;
  dismissedDefaultDocumentLanguageTip?: boolean;
  schedule?: {
    sortOrder?: "asc" | "desc";
  };
  dismissedAlerts?: {
    webinar?: boolean;
    signingImprovements?: boolean;
    followUp?: boolean;
  };
  dismissedAnnouncement?: string;
};

export const initUserPrefs = (): UserPrefs =>
  JSON.parse(localStorage.getItem("user-prefs") ?? "{}") ?? {};

const storeUserPrefs = (): DCEvent => ({
  type: "with-store",
  events: ({ userPrefs }) => [{ type: "update-local-storage", key: "user-prefs", val: userPrefs }],
});

export const updateUserPrefEvent = <T extends keyof UserPrefs>(
  key: T,
  val: UserPrefs[T],
): DCEvent[] => [
  { type: "update-store", data: { userPrefs: (cur) => ({ ...cur, [key]: val }) } },
  storeUserPrefs(),
];

export const dismissAlert = (
  userPrefs: UserPrefs,
  key: keyof NonNullable<UserPrefs["dismissedAlerts"]>,
): DCEvent[] => [
  {
    type: "update-store",
    data: {
      userPrefs: {
        ...userPrefs,
        dismissedAlerts: { ...userPrefs.dismissedAlerts, [key]: true },
      },
    },
  },
  storeUserPrefs(),
];

export const isAlertDismissed = (
  userPrefs: UserPrefs,
  key: keyof NonNullable<UserPrefs["dismissedAlerts"]>,
): boolean => userPrefs.dismissedAlerts?.[key] === true;
